/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Option_TextInputs */



/**
* | output |
* | --- |
* | "Text" |
*
* @param {Compare_Event_Groups_Option_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_option_text = /** @type {((inputs?: Compare_Event_Groups_Option_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Option_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Texte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Text")
	if (locale === "it") return /** @type {LocalizedString} */ ("Testo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Текст")
	if (locale === "es") return /** @type {LocalizedString} */ ("Texto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("文章")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मूलपाठ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Texto")
	return /** @type {LocalizedString} */ ("Text")
});